export default function About() {
  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-16 text-slate-700 dark:text-slate-300">
      <h1 className="text-4xl font-bold">About Us</h1>
      <p className="mt-6 text-lg">
        Born from a collaboration between three experts, a veteran with over 35 years in the crane industry, a seasoned software developer, and a small business IT and systems consultant—our software fills a long-standing gap in the mobile crane hire industry. 
      </p>
      <p className="mt-6 text-lg">
        Designed to streamline fleet management and bookings, it addresses a critical pain point in an industry where scheduling and resource allocation are often manual, fragmented, and inefficient.
      </p>
      <div className="mt-10 grid md:grid-cols-3 gap-6">
        <div className="dark:glass rounded-2xl p-6 bg-primary/70 border-2 border-yellow-500">
          <h3 className="font-semibold text-xl">Industry Focused</h3>
          <p className="mt-2">By focusing specifically on the needs of crane hire operations, our solution significantly reduces admin overhead and resourcing headaches.</p>
        </div>
        <div className="dark:glass rounded-2xl p-6 bg-primary/70 border-2 border-yellow-500">
          <h3 className="font-semibold text-xl">Born from the industry</h3>
          <p className="mt-2">The platform offers end-to-end fleet visibility, intelligent booking workflows, and seamless communication—all in one place.</p>
        </div>
        <div className="dark:glass rounded-2xl p-6 bg-primary/70 border-2 border-yellow-500">
          <h3 className="font-semibold text-xl">UK Based Development & Support</h3>
          <p className="mt-2">Based in the UK, we understand the unique challenges faced by local crane hire businesses.</p>
        </div>
        <div className="dark:glass rounded-2xl p-6 col-start-2 bg-primary/70 border-2 border-yellow-500">
          <h3 className="font-semibold text-xl">Cloud Based Hosting</h3>
          <p className="mt-2">Our cloud-based solution ensures your data is secure, accessible, and scalable as your business grows.</p>
        </div>
      </div>
    </div>
  )
}
